import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { ManualMessageViewedEvent } from '@post-office/placement-contexts/message-viewed-component';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--rovo-expansion/atlas-home-for-you-main-content';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import { type MessageTemplateContext } from '../../..';

import { OnboardingChecklist } from '../../../common/components/OnboardingChecklist';

import { type RecentJiraProjectInfo } from '../../../common/types';

type HydrationResult = MessageTemplateContext & {
	recentJiraProjectInfo?: RecentJiraProjectInfo;
};

type MessageFrontendProps = HydrationResult & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageFrontendProps>(),
		Component: ({
			dismiss,
			completionState,
			tenantId,
			thirdPartyConnectorRecommendations,
			recentJiraProjectInfo,
		}: MessageFrontendProps) => {
			return (
				<ManualMessageViewedEvent>
					<OnboardingChecklist
						onDismiss={dismiss}
						completionState={completionState}
						thirdPartyConnectorRecommendations={thirdPartyConnectorRecommendations}
						tenantId={tenantId}
						recentJiraProjectInfo={recentJiraProjectInfo}
					/>
				</ManualMessageViewedEvent>
			);
		},
	},
});
